import { render, staticRenderFns } from "./SimpleExamModelChangeActivationType.vue?vue&type=template&id=4806a094&"
import script from "./SimpleExamModelChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./SimpleExamModelChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports